import React from "react";
import { CookieDisclaimer } from "./CookieDisclaimer";
import PageFooter from "./PageFooter";
import CountryUtil from "../uidispatcherapi/CountryUtil";
const hasCountrySiteCoreURL = CountryUtil.getOptionalConfig() || "siteCoreUrl";

const PageBottom = () => {
	return (
		<>
			<PageFooter hasCountrySiteCoreURL={hasCountrySiteCoreURL} />
			<CookieDisclaimer hasCountrySiteCoreURL={hasCountrySiteCoreURL} />
		</>
	);
};

export { PageBottom };
